import PropTypes from 'prop-types';

import BlokoLink from 'bloko/blocks/link';

const PayerLink = ({ payerId }) => (
    <BlokoLink href={`/new/admin/payers/${payerId}`} target="_blank">
        {payerId}
    </BlokoLink>
);

PayerLink.propTypes = {
    payerId: PropTypes.number,
};

export default PayerLink;
